import React from 'react';
import { Scenario } from '@/types';

export type UnflowedGasWarningsProps = {
  scenario: Scenario;
};

export const UnflowedGasWarnings: React.FC<UnflowedGasWarningsProps> = ({
  scenario,
}) => {
  // reciprocal operations are the ones where unflowed gas is flowed to so we can prevent optimizer errors and give details about the issue
  // if there are reciprocal operations, other options of where to flow gas need to be added to the scenario in locations where the gas can flow to, like other market prices, trades, storage, contracts, park and loans, balancing agreements, or a best efforts trade to reduce the amount required to flow
  const reciprocalOps = scenario.operations?.filter(
    (op) => op.is_reciprocal_op,
  );

  if (!reciprocalOps) {
    return null;
  }

  // right now it's telling where the unflowed gas is based on the trade description
  // could also use the point name if there's no description

  return (
    <ul className="list-group my-3">
      {reciprocalOps.map((op) => {
        const trade = scenario.trades.find(
          (trade) =>
            trade.id?.toString() === op.receipt_asset_object_id?.toString(),
        );
        if (!trade) {
          return null;
        }
        return (
          <li key={op.id} className="list-group-item list-group-item-danger">
            {`
              ${Math.ceil(op.delivered_dth)}
              dth of 
              ${trade.buy_sell == 'BUY' ? 'unflowed' : 'undelivered'}
              gas at 
              ${trade.description} 
            `}
          </li>
        );
      })}
    </ul>
  );
};
